import { ApiRequest, DemoData } from 'api/demo/types'
import { Position } from 'typings/common_defs'

const DEMO_STORAGE_KEY = 'demoData'

export function matchRestRequest(
  request: ApiRequest,
  matchStr: string | RegExp,
  method = 'GET'
) {
  const url = request.url
  const reqMethod = request.method || 'GET'
  return Boolean(
    url &&
      reqMethod.toLowerCase() === method.toLowerCase() &&
      !!url.match(matchStr)
  )
}

export function clearDemoData() {
  sessionStorage.removeItem(DEMO_STORAGE_KEY)
}

const emptyDemoData = {
  category: 'general',
  shifts: [],
  workers: [],
  rosters: [],
  locations: [],
  positions: [],
  supervisors: [],
  companyMembers: [],
  assignments: [],
  companyOverrides: {
    takePercentageEstimate: 35,
  },
}

export function getDemoData(): DemoData {
  const demoDataStr = sessionStorage.getItem(DEMO_STORAGE_KEY)
  if (demoDataStr) {
    return JSON.parse(demoDataStr)
  }

  return emptyDemoData as DemoData
}

export function setDemoData(demoData: Record<string, unknown>) {
  sessionStorage.setItem(DEMO_STORAGE_KEY, JSON.stringify(demoData))
}

export function isDemoMode() {
  return !!sessionStorage.getItem(DEMO_STORAGE_KEY)
}

function isDrivingPosition(position: Position) {
  return position.positionTemplateId === 22
}

export function getPayForPosition(position: Position) {
  const isDriving = isDrivingPosition(position)
  // return random pay between 150 and 200 for driving positions
  if (isDriving) {
    return {
      payLumpSum: Math.round(Math.random() * 50 + 150).toFixed(2),
    }
  }

  return {
    payRate: Math.round(Math.random() * 10 + 15).toFixed(2),
  }
}
